import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';

const SiX = React.forwardRef(function SiX2({ title = "X", color = "currentColor", size = 24, ...others }, ref) {
  if (color === "default") {
    color = "#000000";
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref,
      ...others,
      children: [
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("path", { d: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" })
      ]
    }
  );
});
const SiX$1 = SiX;

export { SiX$1 as default };
